exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actionBar {\n  margin-top: 30px;\n  margin-bottom: 25px;\n}\n#startButton {\n  width: 252px;\n  height: 45px;\n  text-align: center;\n}", ""]);

// exports
